<template>
  <div id="admin-menu">
    <v-card color="transparent" flat tile>
      <v-toolbar dense>
        <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->

        <v-toolbar-title>Admin</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-menu :key="item.title" transition="fade-transition" v-for="item in items">
          <template v-slot:activator="{ on }">
            <v-btn depressed flat style="border-radius:0px" v-on="on">{{ item.title }}</v-btn>
          </template>
          <v-list v-if="item.child">
            <v-list-tile
              @click="next(child.name)"
              :color="activeToolbar(child.name)"
              :key="child.title"
              v-for="child in item.child"
            >
              <v-list-tile-title v-text="child.title"></v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <template>
          <v-btn @click="logout()" color="red" depressed flat style="border-radius:0px"
            >Logout</v-btn
          >
        </template>
        <!-- <v-btn icon>
          <v-icon>search</v-icon>
        </v-btn>-->

        <!-- <v-btn icon>
          <v-icon>favorite</v-icon>
        </v-btn>-->

        <!-- <v-btn icon>
          <v-icon>more_vert</v-icon>
        </v-btn>-->
      </v-toolbar>
      <v-content>
        <transition mode="out-in" name="slide-fade">
          <router-view></router-view>
        </transition>
      </v-content>
    </v-card>
  </div>
</template>

<script>
import firebase from 'firebase/app'
export default {
  name: 'admin-menu',
  data() {
    return {
      expand: false,
      items: [
        // { title: 'Home', name: 'admin' },
        {
          title: 'Shop',
          expand: false,
          child: [
            {
              title: 'Edition',
              name: 'shop-edition'
            },
            {
              title: 'Product Edition',
              name: 'shop-edition-product'
            },
            {
              title: 'Orders List',
              name: 'shop-orders'
            }
          ]
        },
        {
          title: 'Consulting',
          expand: false,
          child: [
            {
              title: 'Consulting Topic',
              name: 'admin-consulting-topic'
            },
            {
              title: 'Consulting Case',
              name: 'admin-consulting-case'
            },
            {
              title: 'Search Log',
              name: 'admin-search-log'
            }
          ]
        },
        {
          title: 'Wording',
          expand: false,
          child: [
            {
              title: 'Greeting',
              name: 'greeting'
            },
            {
              title: 'Wording Type',
              name: 'wording-type'
            },
            {
              title: 'Wording',
              name: 'wording'
            }
          ]
        }
      ],
      itemsWording: [
        // { title: 'Home', name: 'admin' },
      ]
    }
  },
  computed: {},
  // beforeRouteLeave(to, from, next) {
  //   const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
  //   if (answer) {
  //     next()
  //   } else {
  //     next(false)
  //   }
  // },
  created() {
    // console.log(this.$route)
  },
  methods: {
    logout() {
      const answer = window.confirm('Do you want to logout ?')
      if (answer) {
        firebase
          .auth()
          .signOut()
          .then(() => {
            localStorage.removeItem('tokenAdmin')
            this.$router.push({ name: 'admin-login' })
          })
      }
    },
    activeToolbar(routeName) {
      return this.$route.name == routeName ? 'primary' : 'black'
    },
    next(routeName) {
      this.$router.push({ name: routeName })
    }
  }
}
</script>

<style lang="scss" scoped></style>
